// CPF
const BLACKLISTCPF = [
  '00000000000',
  '11111111111',
  '22222222222',
  '33333333333',
  '44444444444',
  '55555555555',
  '66666666666',
  '77777777777',
  '88888888888',
  '99999999999',
  '12345678909',
];

const verifierDigitCpf = (digits) => {
  const numbers = digits
    .split('')
    .map(number => parseInt(number, 10));

  const modulus = numbers.length + 1;
  const multiplied = numbers.map((number, index) => number * (modulus - index));
  const mod = multiplied.reduce((buffer, number) => buffer + number) % 11;

  return (mod < 2 ? 0 : 11 - mod);
}

const isValidCpf = (number) => {
  const stripped = (number || '').replace(/[^\d]/g, '');

  // CPF must have 11 chars
  if (!stripped || stripped.length !== 11) {
    return false;
  }

  // CPF can't be blacklisted
  if (BLACKLISTCPF.includes(stripped)) {
    return false;
  }

  let numbers = stripped.substr(0, 9);
  numbers += verifierDigitCpf(numbers);
  numbers += verifierDigitCpf(numbers);

  return numbers.substr(-2) === stripped.substr(-2);
};


// CNPJ

const BLACKLISTCNPJ = [
  '00000000000000',
  '11111111111111',
  '22222222222222',
  '33333333333333',
  '44444444444444',
  '55555555555555',
  '66666666666666',
  '77777777777777',
  '88888888888888',
  '99999999999999',
];

const verifierDigitCnpj = (digits) => {
  let index = 2;

  const reverse = digits.split('').reduce((buffer, number) => {
    return [parseInt(number, 10)].concat(buffer);
  }, []);

  const sum = reverse.reduce((buffer, number) => {
    buffer += number * index;
    index = (index === 9 ? 2 : index + 1);
    return buffer;
  }, 0);

  const mod = sum % 11;
  return (mod < 2 ? 0 : 11 - mod);
};

const isValidCnpj = (number) => {
  const stripped = (number || '').replace(/[^\d]/g, '');

  // CNPJ must have 14 chars
  if (!stripped || stripped.length !== 14) {
    return false;
  }

  // CNPJ can't be blacklisted
  if (BLACKLISTCNPJ.includes(stripped)) {
    return false;
  }

  let numbers = stripped.substr(0, 12);
  numbers += verifierDigitCnpj(numbers);
  numbers += verifierDigitCnpj(numbers);

  return numbers.substr(-2) === stripped.substr(-2);
};

export default {
  isValidCpf,
  isValidCnpj,
}